<template>
  <div class="error404">
    <figure class="broken-pencil">
      <BrokenPencil />
    </figure>
    <div class="message">
      <h3 v-if="reason">{{ message }}</h3>
      <h3 v-else>An authentication error occurred.</h3>
      <button v-if="reason" class="btn btn-lg btn-primary" type="button" @click="goBack">
        {{ $t("message.VeracrossSso.back") }}
      </button>
      <button v-else class="btn btn-lg btn-primary" to="/">Back to PTC Wizard home</button>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import BrokenPencil from "@/assets/broken-pencil.svg";

const route = useRoute();
const router = useRouter();
const { t, te } = useI18n();

const reason = computed(() => {
  const value = route.query.reason;
  return typeof value === "string" ? value : "";
});

const account = computed(() => {
  const value = route.query.account;
  return typeof value === "string" ? value : "";
});

const type = computed(() => (route.query.type === "teacher" ? "teacher" : "parent"));

const message = computed(() => {
  if (reason.value === "wrong_role") {
    return t(
      type.value === "teacher"
        ? "message.VeracrossSso.wrong_role_teacher"
        : "message.VeracrossSso.wrong_role"
    );
  }
  const key = `message.VeracrossSso.${reason.value}`;
  return te(key) ? t(key) : t("message.VeracrossSso.unknown");
});

function goBack() {
  if (!account.value) {
    router.push("/");
    return;
  }
  router.push(
    type.value === "teacher"
      ? { name: "teacher-login", params: { account: account.value } }
      : { name: "parent-login", params: { account: account.value } }
  );
}
</script>
